import React from 'react';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import tw from 'tailwind.macro';

export enum NotificationType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
}

type NotificationProps = {
  icon?: React.ReactNode;
  type: NotificationType;
  customStyle?: FlattenSimpleInterpolation;
  children: React.ReactNode;
};

const Container = styled.div<NotificationProps>`
  ${tw`px-medium py-small rounded-30 flex text-p-small-m leading-p-small-m`}
  gap: var(--size-small);

  ${({ type }) => {
    switch (type) {
      case NotificationType.ERROR:
        return css`
          ${tw`bg-toast-error-light border-toast-error border border-solid`}
        `;
      case NotificationType.SUCCESS:
        return css`
          ${tw`bg-toast-success-light border-toast-success border border-solid`}
        `;
      case NotificationType.WARNING:
        return css`
          ${tw`bg-toast-warning-light border-toast-warning border border-solid`}
        `;

      default:
        return null;
    }
  }}

  ${({ customStyle }) => customStyle}
`;

const Notification = (props: NotificationProps) => {
  return (
    <Container {...props}>
      {props.icon}
      <div>{props.children}</div>
    </Container>
  );
};

export default Notification;
